import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { VISIBILITY_TYPES } from '../utils/savedSearchConstants';
import { pageContentGap, DialogHeader } from "../../../theme";
import { SavedSearch } from '../types';

interface SaveDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  savedSearch: SavedSearch | null;
}

function SaveDialog({ open, onClose, onConfirm, savedSearch }: SaveDialogProps) {
  const theme = useTheme();
  const getMessage = () => {
    if (!savedSearch) {
      return 'Are you sure you want to save this search?';
    }

    let message = `Are you sure you want to save changes to "${savedSearch.name}"?`;

    if (savedSearch.visibility === VISIBILITY_TYPES.PARTNERS) {
      message += ' This search is shared with your trading partners and will be updated for them as well.';
    } else if (savedSearch.visibility === VISIBILITY_TYPES.COMPANY) {
      message += ' This search is shared with other users at your company and will be updated for them as well.';
    }

    return message;
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <div style={{
        height: "10px",
        width: "100%",
        background: theme?.palette?.success?.main || "#4CAF50"
      }}/>
      <DialogTitle style={{ padding: "8px 12px" }}>
        <DialogHeader>
          Confirm Save
        </DialogHeader>
      </DialogTitle>
      <DialogContent style={{ padding: "0 12px 12px 12px" }}>
        <Typography>{getMessage()}</Typography>
      </DialogContent>
      <DialogActions style={{ padding: "0 12px 12px 12px" }}>
        <Grid container justifyContent="flex-end" style={{ borderTop: "1px solid #DCDCDC", paddingTop: "12px", gap: pageContentGap, width: "100%" }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button color="primary" onClick={onConfirm}>Save</Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}

export default SaveDialog;